import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import useAllStores from "hooks/useCurrentUserStores";
import useGetModifiersByStoreId from "../useGetModifiersByStoreId";
import usePlayPauseModifier from "../usePlayPasuseModifier";
import PauseModalContainer from "../Components/PauseModal";
import AppContainer from "components/ui/AppContainer";
import AppPaginatedTable from "components/ui/AppPaginatedTable";
import AppSearchInput from "components/ui/AppSearchInput";
import AppSelect from "components/ui/AppSelect.jsx";
import PlayPause from "../Components/PlayPause";
const PauseModifiers = () => {
  const { t } = useTranslation();
  const { stores, loading } = useAllStores();
  const [selectedStore, setSelectedStore] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [state, setState] = useState({
    currentStoreId: null,
    modifiers: [],
    loading: false,
  });

  const updateState = (key, val) =>
    setState((state) => ({ ...state, [key]: val }));

  const [PauseModel, setPauseModel] = useState({
    open: false,
    modifier: null,
    deafaultOption: {
      value: 6,
      unit: "hours",
      duration: "6_HOURS",
    },
  });

  const setPauseModalState = (key, val) => {
    setPauseModel((prevState) => ({
      ...prevState,
      [key]: val,
    }));
  };

  const getModifiersByStore = useGetModifiersByStoreId(updateState);

  const { handlePlayPause, handleplayPauseModifier } = usePlayPauseModifier({
    setPauseModalState,
    updateState,
    getModifiersByStore,
    state,
  });

  const handleChange = (val) => {
    if (val !== "null" && val) {
      getModifiersByStore(val);
      updateState("currentStoreId", val);
      setSelectedStore(val);
    }
  };

  React.useEffect(() => {
    if (selectedStore || !stores?.length) return;
    handleChange(stores[0]?.value);
  }, [stores, selectedStore]);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const isLoading = state.loading || loading;
  const closeModal = () => {
    setPauseModalState("modifier", null);
    setPauseModalState("deafaultOption", {
      value: 6,
      unit: "hours",
      duration: "6_HOURS",
    });
    setPauseModalState("open", false);
  };
  const ModifierListArr = React.useMemo(() => {
    if (searchTerm === "" || searchTerm === null) {
      return state?.modifiers;
    }
    let searchTermLower = searchTerm.toLowerCase().trim();
    return state?.modifiers.filter((item) =>
      item?.baseLanguage?.name?.toLowerCase()?.includes(searchTermLower)
    );
  }, [state?.modifiers, searchTerm]);

  React.useEffect(() => {
    setCurrentPage(1);
  }, [selectedStore, searchTerm]);

  const columns = [
    {
      title: t("Name"),
      dataIndex: "baseLanguage",
      key:'name',
      align: "initial",
      render: (baseLanguage, row, index) => {
        return baseLanguage?.name;
      },
    },

    {
      title: t("Availability"),
      key:'availability',
      align: "initial",
      dataIndex: "_id",
      render: (val, row, index) => {
        return (
          <PlayPause
            {...{
              rowData: row,
              state,
              handlePlayPause,
            }}
          />
        );
      },
    },

    {
      title: t("Maximum Order Quantity"),
      dataIndex: "maximumOrderQuantity",
      key:'maximumOrderQuantity',
      align: "initial",
      sorter: {
        compare: (a, b) => a.maximumOrderQuantity - b.maximumOrderQuantity,
        multiple: 3,
      },
    },
    {
      title: t("Price"),
      dataIndex: "price",
      key:'price',
      align: "initial",
      sorter: {
        compare: (a, b) => a.price - b.price,
        multiple: 3,
      },
      render: (val, row, index) => {
        return (
          <span className="whitespace-nowrap">{`${t(
            "AED"
          )}${"  "} ${val}`}</span>
        );
      },
    },
  ];
  return (
    <AppContainer title={t("Pause Modifiers")} subTitle={t("Select store from the dropdown to play/pause inventory for particular store")} loading={isLoading} containerProps={{ className: "overflow-y-hidden" }}>
      <div className="my-3 flex flex-col md:flex-row md:items-end justify-between">
        <div className="w-full md:w-1/4">
        <AppSelect label={t("Select store")} options={stores} value={selectedStore} onChange={(v)=>handleChange(v)}/>
        </div>
        <div className="w-full md:w-1/4 my-3 md:my-0">
          <AppSearchInput searchTerm={searchTerm} onInput={(e)=>setSearchTerm(e.target.value)} placeholder={t("Search by modifier name")} />
          
        </div>
      </div>
      <AppPaginatedTable
        columns={columns}
        data={ModifierListArr}
        clientSidePagination={true}
        pageSize={pageSize}
        page={currentPage}
        total={ModifierListArr?.length}
        onPageChange={(page, pageSize) => handlePageChange(page, pageSize)}
      />
      <PauseModalContainer
         heading={t("Pause modifier")}
         title1={PauseModel?.modifier?.baseLanguage?.name}
         title2="Select a time frame where item will be paused. After this time, it'll be automatically resumed"
         isLoading={isLoading}
         {...{ PauseModel, closeModal, setPauseModalState }}
         playPauseItem={handleplayPauseModifier}
       />
    </AppContainer>
  );
};
export default PauseModifiers;
